import { BrandManagamentService } from './brand-managament.service';
import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as BrandManagamentActions from './brand-managament.action';
import * as BrandManagamentModels from '../../models/brand-managament/brand-managament';
import * as SearchModels from '../../models/brand-managament/brand-managamentSearch';
import { BannerService } from '../../shared/services/banner.service';
import { SaveState } from '../../models/commonModels';
import { HelperService } from '../../../../src/app/services/helper/helper.service';

export interface BrandManagamentStateModel {
  BrandManagamentSave: SaveState;
  BrandManagamentList: BrandManagamentModels.BrandManagamentListModel;
  BrandManagament: BrandManagamentModels.BrandManagamentModel;
  BrandManagamentSearch: SearchModels.BrandManagamentSearchModel;
  ProducerDictionary: BrandManagamentModels.ProducerListModel;
}

@State<BrandManagamentStateModel>({
    name: 'brandmanagamentState',
    defaults: {
      ProducerDictionary: null,
      BrandManagamentList: null,
      BrandManagamentSave: null,
      BrandManagament: null,
      BrandManagamentSearch: null
    }
})

@Injectable()

export class BrandManagamentState {
constructor( private helperService: HelperService,
             private brandManagamentService: BrandManagamentService,
             private bannerService: BannerService ) { }

@Selector()
    static BrandManagamentList(state: BrandManagamentStateModel) {
    return state.BrandManagamentList;
  }

@Selector()
  static ProducerDictionary(state: BrandManagamentStateModel) {
  return state.ProducerDictionary;
}

  @Selector()
  static BrandManagamentSave(state: BrandManagamentStateModel) {
    return state.BrandManagamentSave;
  }

@Selector()
  static BrandManagament(state: BrandManagamentStateModel) {
    return state.BrandManagament;
  }

@Selector()
  static BrandManagamentSearch(state: BrandManagamentStateModel) {
    return state.BrandManagamentSearch;
  }


@Action(BrandManagamentActions.GetProducerDictionary)
getProducerDistionary(
    context: StateContext<BrandManagamentStateModel>,
    action: BrandManagamentActions.GetProducerDictionary
  ) {

    const errorMessage = 'Błąd pobierania słownika producentów.';

    context.setState(
      patch({
        BrandManagamentList: null
      })
    );

    this.brandManagamentService.getProducerDictionary().subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            ProducerDictionary: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('BrandManagamentActions.GetBrandManagamentList', error);

        this.bannerService.error(errorMessage);
      });
  }


@Action(BrandManagamentActions.GetBrandManagamentList)
getBrandManagamentList(
    context: StateContext<BrandManagamentStateModel>,
    action: BrandManagamentActions.GetBrandManagamentList
  ) {

    const errorMessage = 'Błąd pobierania listy marek.';

    context.setState(
      patch({
        BrandManagamentList: null
      })
    );

    this.brandManagamentService.getList(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            BrandManagamentList: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('BrandManagamentActions.GetBrandManagamentList', error);

        this.bannerService.error(errorMessage);
      });
  }


@Action(BrandManagamentActions.SetBrandManagamentSearch)
setBrandManagamentSearch(
    context: StateContext<BrandManagamentStateModel>,
    action: BrandManagamentActions.SetBrandManagamentSearch
  ) {

    action.Search.CurrentPage = 1;
    context.setState(
      patch({
        BrandManagamentSearch: action.Search
      }));

    context.dispatch(new BrandManagamentActions.GetBrandManagamentList(action.Search));
  }


@Action(BrandManagamentActions.DisposeSearch)
  disposeSearch(
    context: StateContext<BrandManagamentStateModel>
  ) {

    context.setState(
      patch({
        BrandManagamentSearch: null
      }));
}

@Action(BrandManagamentActions.SetBrandManagamentListPage)
setDepositeListPage(
    context: StateContext<BrandManagamentStateModel>,
    action: BrandManagamentActions.SetBrandManagamentListPage
  ) {

    context.setState(
      patch({
        BrandManagamentSearch: action.Search
      }));

    context.dispatch(new BrandManagamentActions.GetBrandManagamentList(action.Search));
  }

@Action(BrandManagamentActions.ResetBrandManagamentSearch)
resetDepositeSearch(
    context: StateContext<BrandManagamentStateModel>
  ) {

    const state = context.getState();

    const brandmanagamentSearch = new SearchModels.BrandManagamentSearchModel();

    brandmanagamentSearch.ItemsPerPage = state.BrandManagamentSearch.ItemsPerPage;

    context.setState(
      patch({
        BrandManagamentSearch: brandmanagamentSearch
      }));

    context.dispatch(new BrandManagamentActions.GetBrandManagamentList(state.BrandManagamentSearch));
  }

@Action(BrandManagamentActions.DeleteBrandItem)
deleteBrandItem(
    context: StateContext<BrandManagamentStateModel>,
    action: BrandManagamentActions.DeleteBrandItem
  ) {

    const errorMessage = 'Błąd podczas usuwania marki.';

    context.setState(
      patch({
        BrandManagamentSave: null
      })
    );

    this.brandManagamentService.deleteBrand(action.BrandId).subscribe((ret) => {
      if (ret === action.BrandId) {
        context.setState(
          patch({
            BrandManagamentSave: new SaveState(action.BrandId, true )
          })
        );

        return ret;

      } else {
        this.bannerService.error(errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('BrandManagamentActions.DeleteBrandManagamentItem', error);

        this.bannerService.error(errorMessage);
      });
}

@Action(BrandManagamentActions.DeleteProducerItem)
deleteProducerItem(
    context: StateContext<BrandManagamentStateModel>,
    action: BrandManagamentActions.DeleteProducerItem
  ) {

    const errorMessage = 'Błąd podczas usuwania producenta.';

    context.setState(
      patch({
        BrandManagamentSave: null
      })
    );

    this.brandManagamentService.deleteProducer(action.ProducerId).subscribe((ret) => {
      if (ret === action.ProducerId) {
        context.setState(
          patch({
            BrandManagamentSave: new SaveState(action.ProducerId, true )
          })
        );

        return ret;

      } else {
        this.bannerService.error(errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('BrandManagamentActions.DeleteBrandManagamentItem', error);

        this.bannerService.error(errorMessage);
      });
}


@Action(BrandManagamentActions.InsertProducer)
insertProducer(
    context: StateContext<BrandManagamentStateModel>,
    action: BrandManagamentActions.InsertProducer
  ) {
    const errorMessage = 'Błąd zapisu nowego producenta.';

    context.setState(
      patch({
        BrandManagamentSave: null
      })
    );

    this.brandManagamentService.insertProducer(action.Producer).subscribe(
      ret => {
        this.bannerService.success('Dodano nowego producenta.');
        context.setState(
          patch({
            BrandManagamentSave: new SaveState(null, true)
          })
        );
      },

      (error) => {
        context.setState(
          patch({
            BrandManagamentSave: new SaveState(null, false)
          })
        );
        this.helperService.SaveException('BrandManagamentActions.InsertProducer', error);
        this.bannerService.error(`${errorMessage}`);
      },
      () => {});
}

  @Action(BrandManagamentActions.InsertBrand)
  insertBrand(
    context: StateContext<BrandManagamentStateModel>,
    action: BrandManagamentActions.InsertBrand
  ) {
    const errorMessage = 'Błąd zapisu nowej marki.';

    context.setState(
      patch({
        BrandManagamentSave: null
      })
    );

    this.brandManagamentService.insertBrand(action.Brand).subscribe(
      ret => {
        this.bannerService.success('Dodano nową markę.');
        context.setState(
          patch({
            BrandManagamentSave: new SaveState(null, true)
          })
        );
      },

      (error) => {
        context.setState(
          patch({
            BrandManagamentSave: new SaveState(null, false)
          })
        );
        this.helperService.SaveException('BrandManagamentActions.InsertBrand', error);
        this.bannerService.error(`${errorMessage}`);
      },
      () => {});
  }


  @Action(BrandManagamentActions.SetProducer)
  SetProducer(
      context: StateContext<BrandManagamentStateModel>,
      action: BrandManagamentActions.SetProducer
    ) {
      const errorMessage = 'Błąd podczas zapisu danych producenta.';

      context.setState(
        patch({
          BrandManagamentSave: null
        })
      );

      this.brandManagamentService.setProducer(action.Producer).subscribe(
        ret => {
          this.bannerService.success('Zaktualizowano dane producenta.');
          context.setState(
            patch({
              BrandManagamentSave: new SaveState(null, true)
            })
          );
        },

        (error) => {
          context.setState(
            patch({
              BrandManagamentSave: new SaveState(null, false)
            })
          );
          this.helperService.SaveException('BrandManagamentActions.SetProducer', error);
          this.bannerService.error(`${errorMessage}`);
        },
        () => {});
  }

  @Action(BrandManagamentActions.SetBrand)
  SetBrand(
    context: StateContext<BrandManagamentStateModel>,
    action: BrandManagamentActions.SetBrand
  ) {
    const errorMessage = 'Błąd zapisu danych marki.';

    context.setState(
      patch({
        BrandManagamentSave: null
      })
    );

    this.brandManagamentService.setBrand(action.Brand).subscribe(
      ret => {
        this.bannerService.success('Zaktualizowano dane marki.');
        context.setState(
          patch({
            BrandManagamentSave: new SaveState(null, true)
          })
        );
      },

      (error) => {
        context.setState(
          patch({
            BrandManagamentSave: new SaveState(null, false)
          })
        );
        this.helperService.SaveException('BrandManagamentActions.InsertBrand', error);
        this.bannerService.error(`${errorMessage}`);
      },
      () => {});
  }


}
